module.exports = __webpack_public_path__ + "static/img/CashTodayUpdateCenterClaro.6601e669.svg";